import { render, staticRenderFns } from "./DetailBanner.vue?vue&type=template&id=576bbc63&scoped=true"
import script from "./DetailBanner.vue?vue&type=script&lang=js"
export * from "./DetailBanner.vue?vue&type=script&lang=js"
import style0 from "./DetailBanner.vue?vue&type=style&index=0&id=576bbc63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576bbc63",
  null
  
)

export default component.exports